export default __webpack_public_path__ + "assets/plume.3b05bb0c.gif";